import * as React from "react";
import { ArrowRight } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const promoCards = [{
  id: 1,
  title: "Hollywood Smile",
  subtext: "Gülüş estetiğine yönelik kişiye özel tasarım ve lamine çözümleri",
  note: "En Popüler Tercih",
  buttonText: "Detayları İncele",
  buttonLink: "/HollywoodSmilePage",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1617553/img/hollywood_smile_treatment.png",
  bgClass: "bg-card/50 backdrop-blur-sm border-0 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300",
  btnVariant: "default" as const
}, {
  id: 2,
  title: "İmplant Tedavisi",
  subtext: "Eksik dişlerin fonksiyon ve estetiğini geri kazandıran özel implantlar",
  note: "Ömür Boyu Kullanım",
  buttonText: "Detayları İncele",
  buttonLink: "/ImplantTreatmentPage",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1617553/img/implant_surgery.png",
  bgClass: "bg-card/50 backdrop-blur-sm border-0 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300",
  btnVariant: "default" as const
}, {
  id: 3,
  title: "Diş Beyazlatma",
  subtext: "Diş minesine zarar vermeyen, size özel profesyonel beyazlatma",
  note: "Hızlı ve Etkili",
  buttonText: "Detayları İncele",
  buttonLink: "/TeethWhiteningPage",
  imageSrc: "https://dtaysegul.10web.cloud/wp-content/uploads/2026/04/dis-beyazlatma.jpg?v=d5ujk9dgb64",
  bgClass: "bg-card/50 backdrop-blur-sm border-0 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300",
  btnVariant: "default" as const,
  hasOverlay: true
}, {
  id: 4,
  title: "Zirkonyum Kaplama",
  subtext: "Dayanıklılık ve estetiği birleştiren özel zirkonyum restorasyonlar",
  note: "Doğal Görünüm",
  buttonText: "Detayları İncele",
  buttonLink: "/ZirconiumCoatingPage",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1617553/img/zirconium_dental.png",
  bgClass: "bg-card/50 backdrop-blur-sm border-0 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300",
  btnVariant: "default" as const
}, {
  id: 5,
  title: "Lamine Diş (Yaprak Porselen)",
  subtext: "Kusursuz bir görünüm için diş yapısına özel porselen yapraklar",
  note: "Minimal Müdahale",
  buttonText: "Detayları İncele",
  buttonLink: "/LamineToothPage",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1617553/img/veneer_porcelain.png",
  bgClass: "bg-card/50 backdrop-blur-sm border-0 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300",
  btnVariant: "default" as const
}, {
  id: 13,
  title: "Estetik Dolgu (Bonding)",
  subtext: "Diş kusurlarını anında gideren özel estetik dolgu ve bonding",
  note: "Hızlı Restorasyon",
  buttonText: "Detayları İncele",
  buttonLink: "/AestheticFillPage",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1617553/img/bonding_filling.png",
  bgClass: "bg-card/50 backdrop-blur-sm border-0 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300",
  btnVariant: "default" as const
}, {
  id: 8,
  title: "Ortodontik Tedaviler",
  subtext: "Diş çapraşıklıklarını gideren, yaşınıza özel ortodontik planlar",
  note: "Düzgün Dişler",
  buttonText: "Detayları İncele",
  buttonLink: "/OrthodonticTreatmentsPage",
  imageSrc: "https://dtaysegul.10web.cloud/wp-content/uploads/2026/04/ortodonti.jpg?v=vvx9k0s5ror",
  bgClass: "bg-card/50 backdrop-blur-sm border-0 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300",
  btnVariant: "default" as const
}, {
  id: 11,
  title: "Şeffaf Plak Tedavisi",
  subtext: "Şeffaf plaklarla konforlu ve size özel diş düzeltme deneyimi",
  note: "Şeffaf Konfor",
  buttonText: "Detayları İncele",
  buttonLink: "/TransparentPlateTreatmentPage",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1617553/img/invisalign_plates.png",
  bgClass: "bg-card/50 backdrop-blur-sm border-0 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300",
  btnVariant: "default" as const
}, {
  id: 6,
  title: "Kanal Tedavisi",
  subtext: "Dişinizi kurtarmaya yönelik modern ve hassas kök kanal tedavisi",
  note: "Konforlu Süreç",
  buttonText: "Detayları İncele",
  buttonLink: "/RootCanalTreatmentPage",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1617553/img/root_canal_therapy.png",
  bgClass: "bg-card/50 backdrop-blur-sm border-0 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300",
  btnVariant: "default" as const
}, {
  id: 9,
  title: "Çocuk Diş Hekimliği",
  subtext: "Çocukların diş gelişimine ve psikolojisine özel yaklaşımlar",
  note: "Pedodonti Uzmanlığı",
  buttonText: "Detayları İncele",
  buttonLink: "/PediatricDentistryPage",
  imageSrc: "https://dtaysegul.10web.cloud/wp-content/uploads/2026/04/pedodonti.jpg?v=ey9mvyxi53k",
  bgClass: "bg-card/50 backdrop-blur-sm border-0 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300",
  btnVariant: "default" as const
}, {
  id: 15,
  title: "Diş Sıkma Botoksu",
  subtext: "Diş sıkma ve çene eklemi ağrıları için özel botoks uygulamaları",
  note: "Çene Eklemi Sağlığı",
  buttonText: "Detayları İncele",
  buttonLink: "/TeethClenchingBotoxPage",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1617553/img/jaw_botox.png",
  bgClass: "bg-card/50 backdrop-blur-sm border-0 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300",
  btnVariant: "default" as const
}, {
  id: 7,
  title: "Özel Tedaviler",
  subtext: "Ağız kokusu, diş gıcırdatma ve horlama gibi özel sorunlara yönelik çözümler",
  note: "Diş Eti Sağlığı",
  buttonText: "Detayları İncele",
  buttonLink: "/SpecialTreatmentsPage",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1617553/img/periodontal_care.png",
  bgClass: "bg-card/50 backdrop-blur-sm border-0 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300",
  btnVariant: "default" as const
}, {
  id: 14,
  title: "Diş Eti Tedavileri",
  subtext: "Diş eti çekilmesi ve hastalıklarına yönelik özel uzmanlık çözümleri",
  note: "Periodontoloji",
  buttonText: "Detayları İncele",
  buttonLink: "/GumTreatmentsPage",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1617553/img/gum_health.png",
  bgClass: "bg-card/50 backdrop-blur-sm border-0 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300",
  btnVariant: "default" as const
}, {
  id: 10,
  title: "Gömülü Diş Operasyonları",
  subtext: "Gömülü ve sorunlu dişler için uzman cerrahi müdahale seçenekleri",
  note: "Uzman Cerrahi",
  buttonText: "Detayları İncele",
  buttonLink: "/ImpactedToothSurgeriesPage",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1617553/img/wisdom_tooth_extraction.png",
  bgClass: "bg-card/50 backdrop-blur-sm border-0 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300",
  btnVariant: "default" as const
}, {
  id: 12,
  title: "Diş Taşı Temizliği",
  subtext: "Diş eti sağlığını korumaya yardımcı özel derin temizlik işlemleri",
  note: "Derin Temizlik",
  buttonText: "Detayları İncele",
  buttonLink: "/DentalPlaqueCleaningPage",
  imageSrc: "https://dtaysegul.10web.cloud/wp-content/uploads/2026/04/dis-tasi.webp?v=7yvm541yot",
  bgClass: "bg-card/50 backdrop-blur-sm border-0 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300",
  btnVariant: "default" as const
}];
export default function PromoCards() {
  return <section data-section-id="194054" id="tedavi-kartları" className="py-24 px-6 bg-background text-foreground">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {promoCards.map((card, i) => {
          return <Link key={card.id} to={card.buttonLink} data-index={i} className="block h-full group no-underline relative z-40">
                <Card className={`relative z-30 flex flex-col justify-between min-h-[300px] h-full rounded-sm transition-all duration-300 ${card.bgClass}`}>
                  {card.hasOverlay && <div className="absolute inset-0 bg-background/5 z-0 pointer-events-none" />}
                  <div className="relative z-10 flex flex-col h-full">
                    <CardHeader className="pt-6 pb-2">
                      <img src={card.imageSrc} alt={card.title} className="w-full h-56 mb-6 object-cover rounded-sm shadow-sm" />
                      <CardTitle className="text-3xl font-serif font-bold tracking-tight text-foreground">
                        {card.title}
                      </CardTitle>
                      {card.note && <p className="text-[10px] font-sans font-bold tracking-[0.2em] text-primary uppercase mt-4 mb-1">
                          {card.note}
                        </p>}
                      <CardDescription className="text-sm font-sans font-medium text-muted-foreground/80 mt-2 leading-relaxed">
                        {card.subtext}
                      </CardDescription>
                    </CardHeader>
                    <CardFooter className="pt-6 pb-8 mt-auto">
                      <Button asChild variant={card.btnVariant} className="w-full sm:w-auto font-sans font-semibold text-base tracking-wide rounded-sm bg-primary hover:bg-primary/90 text-primary-foreground transition-all">
                        <span>
                          {card.buttonText} <ArrowRight className="ml-2 w-5 h-5" />
                        </span>
                      </Button>
                    </CardFooter>
                  </div>
                </Card>
              </Link>;
        })}
        </div>
      </div>
    </section>;
}